module.exports = __webpack_public_path__ + "img/portrait02.6cb2e883.jpg";